import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { Modal, ModalFooter, ModalHeader } from '@winelidays/wld-tsx-2/modules';
const FilterModal = (t0) => {
    const $ = _c(34);
    const { children, countAfterApply: t1, filterName, hasDiffWithActive, hasDiffWithInitial, isOpen, modalTitle: incomingModalTitle, onApply, onCancelChanges, onClose, onReset } = t0;
    const countAfterApply = t1 === undefined ? null : t1;
    const translate = useTranslate();
    const canCancel = hasDiffWithActive && !!onCancelChanges;
    const modalTitle = incomingModalTitle ?? `${translate("messages.filter_by")} ${filterName}`;
    let t2;
    if ($[0] !== countAfterApply || $[1] !== translate) {
        t2 = countAfterApply !== null ?
            translate("messages.see_x_results", { count: countAfterApply }) :
            translate("messages.apply");
        $[0] = countAfterApply;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const applyLabel = t2;
    let t3;
    if ($[3] !== canCancel || $[4] !== translate) {
        t3 = canCancel ?
            translate("messages.cancel_filters_change") :
            translate("messages.reset_filters");
        $[3] = canCancel;
        $[4] = translate;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    const resetLabel = t3;
    let t4;
    if ($[6] !== canCancel || $[7] !== onCancelChanges || $[8] !== onReset) {
        t4 = () => {
            if (canCancel && onCancelChanges) {
                onCancelChanges();
            }
            else {
                onReset();
            }
        };
        $[6] = canCancel;
        $[7] = onCancelChanges;
        $[8] = onReset;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    const handleReset = t4;
    const isApplyDisabled = !hasDiffWithActive || countAfterApply === 0;
    let t5;
    if ($[10] !== modalTitle) {
        t5 = <ModalHeader title={modalTitle}/>;
        $[10] = modalTitle;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    let t6;
    if ($[12] !== children) {
        t6 = <>{children}</>;
        $[12] = children;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    let t7;
    if ($[14] !== applyLabel || $[15] !== isApplyDisabled || $[16] !== onApply) {
        t7 = <Button onClick={onApply} disabled={isApplyDisabled} className="btn-primary !p-3 xxs:!py-4 xxs:!px-10" title={applyLabel}>

      {applyLabel}
    </Button>;
        $[14] = applyLabel;
        $[15] = isApplyDisabled;
        $[16] = onApply;
        $[17] = t7;
    }
    else {
        t7 = $[17];
    }
    let t8;
    if ($[18] !== canCancel || $[19] !== handleReset || $[20] !== hasDiffWithInitial || $[21] !== resetLabel) {
        t8 = hasDiffWithInitial || canCancel ?
            <Button onClick={handleReset} className="btn-ghost-outline !p-4 ml-4 " disabled={!hasDiffWithInitial && !canCancel} title={resetLabel}>

      {resetLabel}
    </Button> : null;
        $[18] = canCancel;
        $[19] = handleReset;
        $[20] = hasDiffWithInitial;
        $[21] = resetLabel;
        $[22] = t8;
    }
    else {
        t8 = $[22];
    }
    let t9;
    if ($[23] !== t7 || $[24] !== t8) {
        t9 = <ModalFooter className="flex-row">{t7}{t8}
    </ModalFooter>;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
    }
    else {
        t9 = $[25];
    }
    let t10;
    if ($[26] !== isOpen || $[27] !== modalTitle || $[28] !== onClose || $[29] !== t5 || $[30] !== t6 || $[31] !== t9 || $[32] !== translate) {
        t10 = <Modal isOpen={isOpen} onClose={onClose} dialogLabel={modalTitle} hasStandardHeader={true} isClient={true} translate={translate} className="xs:!w-168">{t5}{t6}{t9}
    </Modal>;
        $[26] = isOpen;
        $[27] = modalTitle;
        $[28] = onClose;
        $[29] = t5;
        $[30] = t6;
        $[31] = t9;
        $[32] = translate;
        $[33] = t10;
    }
    else {
        t10 = $[33];
    }
    return t10;
};
export default FilterModal;
